import i18n from '@/lang/index'
export default {
  name: 'module-manage',
  label: {
    title: i18n.t('module_management'),
    icon: require('@/assets/icon-accessary_ModuleManage.png')
  },
  sort: 2
}
